<template>
  <div class="audio-player-container">
    <div class="audio-player-list">
      <el-scrollbar
        wrap-style="overflow-x: hidden;"
        :style="{ height: '100%'}">
        <ul>
          <template v-for="(file, index) in files">
            <li :class="[currentIndex===index?'active':'']"
                @click="onView(index)">
              <i class="sj-icon-mp3-file"></i>
              <span> {{file.src.substr(-19)}}</span>
            </li>
          </template>
        </ul>
      </el-scrollbar>
    </div>
    <div class="audio-player-content">
      <div v-if="orderMetaText"
           class="audio-player-order-meta"
           :title="orderMetaText">
        {{ orderMetaText }}
      </div>
      <div class="audio-player-lyric"
           ref="lyrics"
           :style="lyricStyle">
        <el-scrollbar
          ref="scrollLyric"
          wrap-style="overflow-x: hidden; position: relative;"
          :style="{ height: '100%'}">
          <ul>
            <template v-for="(row, index) in lyrics">
              <li :class="[
                lyricIndex===index?'active':'',
                isRiskLyric(row) ? 'risk-hit' : ''
              ]">
                <span @click="jumpTime(row.bg)">{{row.onebest}}</span>
              </li>
            </template>
          </ul>
          <div class="audio-player-lyric-tip"
               v-show="!lyrics.length">没有语音识别内容
          </div>
        </el-scrollbar>
      </div>
      <div ref="audioBar">
        <h4 style="text-align: center;">{{src|baseName}}</h4>
        <!-- 播放器 -->
        <div ref="audioMount"
             style="width: 100%;"></div>
        <!-- 播放器扩展内容 -->
        <div v-show="false">
          <button ref="audioPip"
                  style="display: inline-block;"
                  class="plyr__controls__item plyr__control"
                  type="button"
                  data-sj-pip="1"
                  @click.stop.prevent="audioPip">
            <svg role="presentation"
                 focusable="false">
              <use xlink:href="#plyr-pip"></use>
            </svg>
            <span class="plyr__tooltip">画中画</span>
          </button>
          <div ref="markers">
            <template v-if="time > 0"
                      v-for="(marker, index) in markers">
              <el-badge slot="reference"
                        v-if="marker.time > 0 && marker.time <= time"
                        is-dot
                        :type="markerBadgeType(marker)"
                        class="audio-marker"
                        :style="`left: ${marker.time/time*100}%`"
                        @click.stop.native="markerClick()"
                        @mouseover.stop.native="markerOver(index)"
                        @mouseout.stop.native="markerOut()"></el-badge>
            </template>
          </div>
          <div ref="audioTag"
               :class="markerLableClass">
            <template v-if="marker">
              <div v-if="marker.type === 2">
                风险：{{marker.text}}
              </div>
              <div v-else-if="marker.type">
                关键录音标记
              </div>
              <div v-else>
                {{marker.text}}
              </div>
              <div>{{marker.time|formatTimer}}</div>
            </template>
          </div>
        </div>
        <v-contextmenu ref="contextmenu">
          <v-contextmenu-item :disabled="!!contextmenuMarker"
                              @click="addMarker()">添加
          </v-contextmenu-item>
          <v-contextmenu-item :disabled="!contextmenuMarker"
                              @click="editMarker()">编辑
          </v-contextmenu-item>
          <v-contextmenu-item :disabled="!contextmenuMarker"
                              @click="removeMarker()">删除
          </v-contextmenu-item>
        </v-contextmenu>
      </div>
    </div>

    <template>
      <a ref="resDownload"
         class="plyr__controls__item plyr__control"
         href=""
         target="_blank"
         data-plyr="download"
         download
         @click.prevent="onDownload">
        <svg role="presentation"
             focusable="false">
          <use xlink:href="#plyr-download"></use>
        </svg>
        <span class="plyr__tooltip">下载</span></a>
    </template>
  </div>
</template>

<script>
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'
import { Power2, TweenLite } from 'gsap/TweenLite'
import 'gsap/ScrollToPlugin'
import mousetrap from 'mousetrap'
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
import download from 'downloadjs'
import store from '@store'
import AudioSoundHost from '@views/question-review/components/AudioSoundHost'

// 右击菜单显示 https://github.com/snokier/v-contextmenu
Vue.use(contentmenu)

let player = null

export default {
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isOpenThroughRecord: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [Number, String],
      default: '',
    },
    taskTitle: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      currentIndex: this.index,
      lyricIndex: -1,
      containerStyle: '',
      lyricStyle: '',
      audioHeight: 0,
      srcLyrics: {},
      srcLyricLoading: {},
      // 总时长
      time: 0,
      // 右击所在位置时长
      contextmenuTime: null,
      // 进度条的像素长度
      progressBarPx: null,
      // 打点列表
      markerIndex: null,
      // 画中画进行中：关闭全屏弹窗时不要暂停主音频（主音频负责出声）
      pipActive: false,
      srcMarkers: {
        // [
        // {
        //   time: 4.5,
        //   text: '第一个点'
        // },
        // {
        //   time: 12,
        //   text: '我们来试一下十五个字是多长！！'
        // },
        // {
        //   time: 25,
        //   text: '最后一个'
        // }
        // ]
      },
    }
  },
  computed: {
    audio () {
      return AudioSoundHost.audio
    },
    orderMetaText () {
      const orderPart = this.orderId ? `工单 ${this.orderId}` : ''
      const titlePart = (this.taskTitle || '').trim()
      return [orderPart, titlePart].filter(Boolean).join(' · ')
    },
    // AnswerFileFullScreen 是 Vue.extend 挂到 body 的实例，不能依赖组件树注入的 $store
    asrCheckResult () {
      return (store.state.orderReview && store.state.orderReview.asrCheckResult) || null
    },
    asrCheckSeek () {
      return (store.state.orderReview && store.state.orderReview.asrCheckSeek) || null
    },
    src () {
      return this.files[this.currentIndex].src
    },
    playSrc () {
      return filter.ossHost(this.src)
    },
    lyrics () {
      this.requestLyric(this.src)
      return this.srcLyrics[this.src] || []
    },
    markers: {
      get () {
        this.requestMarkers(this.src)
        return this.srcMarkers[this.src] || []
      },
      set (value) {
        this.srcMarkers[this.src] = value
      }
    },
    currentRiskSegments () {
      return this.collectRiskSegmentsForSrc(this.src)
    },
    riskLyricBeginMsSet () {
      const set = {}
      this.currentRiskSegments.forEach((seg) => {
        const ms = Number(seg.begin_ms)
        if (!Number.isNaN(ms)) {
          set[ms] = true
        }
      })
      return set
    },
    marker () {
      return this.markers[this.markerIndex] || null
    },
    markerLableClass () {
      if (this.marker) {
        return 'plyr__tooltip plyr__tooltip--visible'
      } else {
        return 'plyr__tooltip'
      }
    },
    contextmenuMarker () {
      if (this.contextmenuTime >= 0 && this.progressBarPx) {
        // 标记所占像素宽度
        let markerPx = 10
        // 每个像素占用的时间(s)
        let pxByTime = this.time / this.progressBarPx
        // 标记占用的时间
        let markerTime = pxByTime * markerPx
        // 偏移时间
        let offsetTime = markerTime / 2
        return this.markers.find(({time}) => {
          return time - offsetTime <= this.contextmenuTime && this.contextmenuTime <= time + offsetTime
        })
      }
    }
  },
  watch: {
    lyricIndex () {
      let container = this.$refs.scrollLyric.wrap
      let offset = 0
      if (this.lyricIndex !== -1) {
        // 高亮歌词到容器的中间
        let centerHeight = container.clientHeight / 2
        let offsetHeight = 28 * (this.lyricIndex + 1)
        if (offsetHeight > centerHeight) {
          offset = offsetHeight - centerHeight
        }
      }
      // 有效的歌词滚动
      if (container.scrollTop !== 0 || offset !== 0) {
        TweenLite.to(container, 2, {
          scrollTo: offset,
          ease: Power2.easeOut,
        })
      }
    },
    visible (val) {
      if (val) {
        this.registerKeyboard()
        this.onView(this.index)
        this.$nextTick(() => {
          // 打开播放器时强制重拉字幕（避免先前 404 缓存导致一直空白）
          this.reloadLyric(this.src)
          this.applyAsrCheckSeek()
        })
      } else {
        // 画中画靠主音频出声，关闭弹窗时不能 pause
        if (!this.pipActive && this.audio) {
          this.audio.pause()
        }
        mousetrap.reset()
      }
    },
    currentIndex () {
      this.requestThroughRecordMarker()
      this.mergeRiskMarkers()
      this.$nextTick(() => {
        this.reloadLyric(this.src)
        this.applyAsrCheckSeek()
      })
    },
    asrCheckResult () {
      this.mergeRiskMarkers()
    },
    asrCheckSeek () {
      this.applyAsrCheckSeek()
    },
    pipActive (active) {
      // 画中画关掉且大屏已关：停声。大屏还在或刚进入画中画时不处理
      if (active || this.visible || !this.audio) return
      this.audio.pause()
    },
  },
  created () {
    this.registerKeyboard()
    AudioSoundHost.on('pip-closed', this.handlePipClosed)
    AudioSoundHost.on('pip-error', this.handlePipError)
  },
  mounted () {
    this.create()
    this.$refs.resDownload.href = filter.ossHost(this.src)
    this.requestThroughRecordMarker()
    this.mergeRiskMarkers()
    this.applyAsrCheckSeek()
  },
  destroyed () {
    AudioSoundHost.off('pip-closed', this.handlePipClosed)
    AudioSoundHost.off('pip-error', this.handlePipError)
    mousetrap.reset()
    this.destroy()
  },
  methods: {
    markerBadgeType (marker) {
      if (marker && marker.type === 1) return 'success'
      if (marker && marker.type === 2) return 'warning'
      return 'danger'
    },
    audioBasename (url) {
      if (!url) return ''
      const clean = String(url).split('?')[0]
      const parts = clean.split('/')
      return parts[parts.length - 1] || ''
    },
    isSameAudioUrl (a, b) {
      if (!a || !b) return false
      if (a === b) return true
      const ba = this.audioBasename(a)
      const bb = this.audioBasename(b)
      return ba && bb && ba === bb
    },
    collectRiskSegmentsForSrc (src) {
      const detail = this.asrCheckResult
      if (!detail || Number(detail.status) !== 6 || !Array.isArray(detail.items)) {
        return []
      }
      const list = []
      detail.items.forEach((item) => {
        if (Number(item.is_trigger_risk) !== 1) return
        const segments = Array.isArray(item.asr_segments) ? item.asr_segments : []
        segments.forEach((seg) => {
          if (this.isSameAudioUrl(src, seg.record_url)) {
            list.push(Object.assign({}, seg, {
              alias: item.alias || '',
              answer: item.answer || '',
            }))
          }
        })
      })
      return list
    },
    isRiskLyric (row) {
      if (!row) return false
      const bg = Number(row.bg)
      return !Number.isNaN(bg) && !!this.riskLyricBeginMsSet[bg]
    },
    mergeRiskMarkers () {
      const src = this.src
      if (!src || !this.srcMarkers[src]) {
        return
      }
      const withoutRisk = (this.srcMarkers[src] || []).filter(item => item.type !== 2)
      const riskMarkers = this.collectRiskSegmentsForSrc(src).map((seg) => {
        const beginMs = Number(seg.begin_ms) || 0
        return {
          time: _.ceil(beginMs / 1000, 3),
          text: seg.alias || '风险',
          type: 2,
        }
      })
      this.$set(this.srcMarkers, src, withoutRisk.concat(riskMarkers))
    },
    applyAsrCheckSeek () {
      const seek = this.asrCheckSeek
      if (!seek || !this.visible) return
      const targetUrl = seek.recordUrl || ''
      if (!targetUrl) {
        store.commit('orderReview/SET_ASR_CHECK_SEEK', null)
        return
      }

      let targetIndex = this.files.findIndex(file => this.isSameAudioUrl(file.src, targetUrl))
      if (targetIndex < 0) {
        // 当前文件列表无目标录音：清空 seek，避免后续误跳
        store.commit('orderReview/SET_ASR_CHECK_SEEK', null)
        return
      }

      if (targetIndex !== this.currentIndex) {
        this.onView(targetIndex)
      }
      const beginMs = Number(seek.beginMs) || 0
      this.$nextTick(() => {
        this.jumpTime(beginMs)
        store.commit('orderReview/SET_ASR_CHECK_SEEK', null)
      })
    },
    async requestMarkers (src) {
      if (!this.srcMarkers[src]) {
        try {
          this.$set(this.srcMarkers, src, [])
          const [adminMarkers, appMarkers] = await Promise.all([
            this.requestManagerMarkers(src),
            this.requestAppMarkers(src)
          ])

          // 合并结果（风险点 type=2 不入库，仅内存叠加）
          this.$set(this.srcMarkers, src, [
            ...adminMarkers,
            ...appMarkers
          ])
          this.mergeRiskMarkers()
        } catch (error) {
          console.error('Error fetching markers:', error)
        }
      }
    },
    create () {
      if (player) return
      if (AudioSoundHost.isPipActive) {
        this.pipActive = true
      }
      const keepGoing = this.pipActive && !AudioSoundHost.paused
      AudioSoundHost.setSrc(this.playSrc, {autoplay: !keepGoing})
      const el = AudioSoundHost.borrow(this.$refs.audioMount)
      el.addEventListener('timeupdate', this.updateTime)
      el.addEventListener('error', this.error)
      player = new Plyr(el, {
        tooltips: {controls: true},
        volume: 10,
        invertTime: false,
        toggleInvert: false,
        // keyboard: {global: true},
        controls: [
          'play-large',
          // 'restart',
          // 'rewind',
          'play',
          // 'fast-forward',
          'progress',
          'current-time',
          'duration',
          'mute',
          'volume',
          // 'captions',
          'settings',
          // 使用自定义 Document PiP，不走 Plyr 内置 pip（会抢点击并打断播放）
          // 'pip',
          'airplay',
          // 'download',
          'fullscreen',
        ],
        i18n: {
          play: '播放',
          pause: '暂停',
          mute: '静音',
          unmute: '取消静音',
          download: '下载',
          pip: '画中画',
          settings: '设置',
          speed: '速度',
          normal: '正常',
        },
      })
      player.on('ready', event => {
        $('.plyr__menu', this.$el).append(this.$refs.resDownload)
        $('.plyr__controls', this.$el).append(this.$refs.audioPip)
        $('.plyr__progress', this.$el).append(this.$refs.audioTag)
        $('.plyr__progress', this.$el).append(this.$refs.markers)
        $('.plyr__progress', this.$el).contextmenu(({clientX, clientY}) => {
          // 获得右击属于的时间
          let position = $('.plyr__progress input', this.$el)[0].getBoundingClientRect()
          let left = clientX - position.left
          let length = position.right - position.left
          let progress = left / length
          let time = this.time * progress
          this.progressBarPx = length
          this.contextmenuTime = time
          // 显示菜单
          this.$refs.contextmenu.show({
            left: clientX,
            top: clientY - 58
          })
          return false
        })
      })
      player.on('loadedmetadata', event => {
        // 获得音频持续时长
        this.time = player.duration
      })
      this.$nextTick(() => {
        let audioBarHeight = this.$refs.audioBar.clientHeight
        let borderBottom = 15
        const metaEl = this.$el && this.$el.querySelector
          ? this.$el.querySelector('.audio-player-order-meta')
          : null
        const metaHeight = metaEl ? metaEl.offsetHeight : 0
        this.lyricStyle = `height: calc(100% - ${audioBarHeight + borderBottom + metaHeight}px);`
      })
    },
    destroy () {
      const el = this.audio
      const keep = this.pipActive && el && !el.paused
      if (el) {
        el.removeEventListener('timeupdate', this.updateTime)
        el.removeEventListener('error', this.error)
      }
      if (player) {
        try {
          player.destroy()
        } catch (e) {}
        player = null
      }
      AudioSoundHost.release()
      if (keep) {
        el.play().catch(function () {})
      }
    },
    registerKeyboard () {
      mousetrap.bind('space', (e) => {
        player.togglePlay()
        return false
      }, 'keyup')
      mousetrap.bind('up', (e) => {
        player.increaseVolume(0.1)
        return false
      }, 'keyup')
      mousetrap.bind('down', (e) => {
        player.decreaseVolume(0.1)
        return false
      }, 'keyup')
    },
    updateLyricIndex (time) {
      let before = null
      let after = null
      let index = this.lyrics.findIndex(
        (lyric, index) => {
          let {bg, ed} = lyric
          // 获得下一句
          after = this.lyrics[index + 1]
          before = lyric

          // 在两句话之间
          if (time >= before.ed && after && time <= after.bg) {
            return true
          }

          // 当前句
          if (time >= bg && time <= ed) {
            return true
          }
        },
      )
      if (index !== -1) {
        this.lyricIndex = index
      }
    },
    updateTime () {
      const audio = this.audio
      if (!audio) return
      this.updateLyricIndex(parseInt(audio.currentTime * 1000))
    },
    jumpTime (time) {
      this.audio.currentTime = time / 1000
    },
    // 在媒体数据已经有足够的数据（至少播放数帧）可供播放时触发。
    canPlay () {
      // console.log('canPlay')
    },
    // 文件加载出错
    error () {
      this.$message.error('文件加载发生错误。')
    },
    ended () {},
    onView (index) {
      this.currentIndex = index
      this.lyricIndex = -1
      console.log(this.src)
      this.$refs.resDownload.href = filter.ossHost(this.src)
      AudioSoundHost.setSrc(this.playSrc, {autoplay: this.visible})
      this.$nextTick(() => {
        this.updateSpeed()
      })
    },
    requestLyric (src) {
      if (!src) return
      // 已有有效字幕或正在请求中则跳过
      if (this.srcLyrics[src] || this.srcLyricLoading[src]) {
        return
      }
      this.$set(this.srcLyricLoading, src, true)
      const lyricSrc = filter.ossHost(src.substring(0, src.lastIndexOf('.')) + '.json')
      // 使用独立实例，避免全局 axios 带鉴权头影响 OSS 跨域
      axios.create().get(lyricSrc).then(({data}) => {
        const list = Array.isArray(data) ? data : []
        this.$set(this.srcLyrics, src, list)
      }).catch((err) => {
        console.warn('加载录音字幕失败', lyricSrc, err)
        // 不写入空数组，允许下次打开时重试
      }).finally(() => {
        this.$set(this.srcLyricLoading, src, false)
      })
    },
    reloadLyric (src) {
      if (!src) return
      this.$delete(this.srcLyrics, src)
      this.$delete(this.srcLyricLoading, src)
      this.requestLyric(src)
    },
    changeSpeed (value) {
      const audio = this.audio
      if (!audio) return
      const rate = Number(value)
      if (!Number.isFinite(rate) || rate <= 0) return
      audio.playbackRate = rate
    },
    updateSpeed () {
      // Plyr 当前倍速优先；未初始化时默认 1，避免写入 NaN/undefined
      const rate = (player && Number.isFinite(Number(player.speed)) && Number(player.speed) > 0)
        ? Number(player.speed)
        : 1
      this.changeSpeed(rate)
    },
    async requestManagerMarkers (src) {
      try {
        let markerSrc = filter.ossHost(src.substring(0, src.lastIndexOf('.')) + '_marker.json')
        const { data } = await axios.get(markerSrc)
        return data
      } catch (e) {
        console.warn(e)
        return []
      }
    },
    async requestAppMarkers (src) {
      const markerSrc = filter.ossHost(src.substring(0, src.lastIndexOf('.')) + '_app_marker.json')
      try {
        const { data } = await axios.get(markerSrc)
        // 标记追加类型
        data.forEach(item => {
          item.type = 1
        })
        return data
      } catch (e) {
        console.warn(e)
        return []
      }
    },
    markerClick () {
      this.audio.currentTime = this.marker.time
    },
    markerOver (index) {
      this.markerIndex = index
      $($('.plyr__progress .plyr__tooltip', this.$el)[0]).attr('hidden', '')
      this.$refs.audioTag.style = `left: ${this.marker.time / this.time * 100}%`
    },
    markerOut () {
      this.markerIndex = null
      $($('.plyr__progress .plyr__tooltip', this.$el)[0]).removeAttr('hidden')
    },
    markerPrompt (inputValue) {
      return this.$prompt(`请输入录音[${filter.formatTimer(this.contextmenuTime)}]的标记内容`, '提示', {
        inputPattern: /^.{1,15}$/,
        inputErrorMessage: '请输入1~15个字符',
        closeOnClickModal: false,
        inputValue
      })
    },
    addMarker () {
      this.markerPrompt().then(({value}) => {
        this.markers.push({
          time: _.ceil(this.contextmenuTime, 3),
          text: value.trim()
        })
        let saveData = this.markers.filter(item => {
          return !('type' in item)
        })
        this.saveMarkers(_.sortBy(saveData, 'time'))
      })
    },
    editMarker () {
      let marker = this.markers[this.markers.indexOf(this.contextmenuMarker)]
      this.markerPrompt(marker.text).then(({value}) => {
        marker.text = value.trim()
        this.saveMarkers(this.markers)
      })
    },
    removeMarker () {
      this.markers.splice(this.markers.indexOf(this.contextmenuMarker), 1)
      this.saveMarkers(this.markers)
    },
    saveMarkers (markers) {
      const url = this.src.replace('.mp3', '_marker.json')
      const params = {
        ext: 'json',
        content_type: 'application/json',
        url
      }

      request.alert('uploadOrderReviewDirectFile', params).then((res) => {
        let uploadUrl = res.data.signedUrl
        fetch(uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(markers),
        }).then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`)
          }
        })
      })
    },
    onDownload () {
      // 替换掉 http, 防止出现 https 向 http 请求的错误
      download(filter.ossHost(this.$refs.resDownload.href))
    },
    requestThroughRecordMarker () {
      // 全程录音 有关键题目
      if (this.isOpenThroughRecord) {
        let jsonsrc = filter.ossHost(this.src.substring(0, this.src.lastIndexOf('.')) + '_throughRecord.json')
        axios.get(filter.ossHost(jsonsrc)).then(({data}) => {
          for (const key in data) {
            const item = data[key]
            this.addKeyMarker(item.time, `第${item.questionIndex}题`)
          }
        }).catch(() => {})
      }
    },
    addKeyMarker (time, title) {
      this.markers.push({
        time: _.ceil(time, 3),
        text: title
      })
    },
    async audioPip () {
      const audio = this.audio
      if (!audio) return
      if (!window.documentPictureInPicture) {
        this.$message.warning('当前浏览器不支持文档画中画')
        return
      }
      if (this.pipActive) {
        this.$message.info('画中画已打开')
        return
      }

      this.pipActive = true
      const success = await AudioSoundHost.openPip({
        audioSrc: this.playSrc,
        lyrics: this.lyrics,
        currentLyricIndex: this.lyricIndex,
        wasPlaying: !audio.paused && !audio.ended,
        currentTime: audio.currentTime || 0,
      })
      if (!success) {
        this.pipActive = false
        this.$message.error('画中画初始化失败')
        return
      }

      // 主音频继续出声；仅关闭外层 UI
      this.$emit('close')
    },
    handlePipClosed ({ currentTime }) {
      this.pipActive = false
      const audio = this.audio
      if (!audio) return
      if (typeof currentTime === 'number' && isFinite(currentTime)) {
        try {
          audio.currentTime = currentTime
        } catch (e) {}
      }
    },
    handlePipError () {
      this.pipActive = false
      this.$message.error('画中画初始化失败')
    },
  },
}
</script>

<style lang="scss">
.audio-player-container {
  height: 100%;
  width: 100%;
  background-color: transparent;
  position: relative;

  .audio-player-content {
    height: 100%;
    width: 100%;
    min-height: 100px;
    box-sizing: border-box;
    padding: 15px 15px 15px 215px;
  }

  .audio-player-order-meta {
    margin: 0 0 10px;
    padding: 8px 12px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.08);
    color: #e6e6e6;
    font-size: 14px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 歌词显示区域 */
  .audio-player-lyric {
    height: 100%;
    position: relative;
    overflow: hidden;
    text-align: center;
    color: #bdbdbe;
    color: rgba(225, 225, 225, .8);
    line-height: 28px;
    box-sizing: border-box;

    // 歌词
    ul {
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;

      & > li {
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        span {
          cursor: pointer;

          &:hover {
            color: #31c27c;
          }
        }
      }

      /* 正在播放的那一句歌词 */
      .active {
        color: #31c27c;
        font-size: 16px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }

      /* ASR 风险命中片段 */
      .risk-hit {
        color: #e6a23c;

        span {
          background: rgba(230, 162, 60, 0.18);
          border-radius: 2px;
          padding: 0 4px;
        }
      }

      .risk-hit.active {
        color: #f56c6c;
      }
    }

    /* 歌词显示区显示的提示语(如加载中、无歌词等) */
    .audio-player-lyric-tip {
      position: absolute;
      width: 100%;
      top: 50%;
    }


  }

  .audio-player-list {
    width: 200px;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.95);;
    padding: 15px 0;
    border-radius: 3px;

    ul {
      margin: 0;
      padding: 0 15px;
      overflow: hidden;

      li {
        margin: 10px 0;
        list-style: none;
        cursor: pointer;
        /* 省略号 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.active {
          color: #409EFF;
        }

        &:hover {
          color: #409EFF;
        }
      }
    }
  }
}
</style>
<style lang="scss"
       scoped>
.audio-marker {
  position: absolute;
  left: 0;
  top: 3.75px;
  z-index: 2;
  margin-left: -6.5px;
  margin-right: -6.5px;
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/AnswerFileFullScreen/src/ViewAudio.vue